import { createSlice } from "@reduxjs/toolkit/"

let initialState = {
    choicesList : [],
    selectedChoice:{},
}
const choicesSlice = createSlice({
    name:'choices',
    initialState,
    reducers:{
        setChoicesList:(state,{payload})=>{
            state.choicesList = payload
        },
        setSelectedChoice:(state,{payload})=>{
            state.selectedChoice = payload
        },
    }
})

export const { setChoicesList,setSelectedChoice } = choicesSlice.actions
export default choicesSlice.reducer